import { Routes } from '@angular/router';
import { SearchOverviewComponent } from './containers/search-overview/search-overview.component';
import { menuThemeGuard } from '../guards/menu-theme.guard';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import * as fromStore from './store';
import { SearchMetaGuard } from './search-meta.guard';

export const routes: Routes = [
  {
    path: '',
    component: SearchOverviewComponent,
    data: {
      navTheme: 'secondary',
    },
    canActivate: [menuThemeGuard, SearchMetaGuard],
    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
